<mtg-data-slider *ngIf="partners && partners.length > 0">
  <mtg-data-slider-item *ngFor="let partner of partners">
    <a [href]="partner.link | safe: 'url'" target="_blank">
      <img [src]="partner.picture.path">
    </a>
  </mtg-data-slider-item>
</mtg-data-slider>
